export const AUTH_CALLBACK_PATH = 'callback';
export const ROOT_PATH = '/';
export const E_SIGN_MSG_ADVISOR_PATH = 'electronicsignature-advisor';
export const PRODUCT_DEFAULT_PATH = 'product/HE';
export const PRODUCT_PATH = 'product/:productCode';
export const PRODUCT_PATH_FROM_PARTNER = 'product/:productCode/:partnerCode';
export const CONTEXT_PATH = 'context/:id';
export const CONFIRM_CONTRACT_PATH = 'confirmcontract';
export const CONFIRM__AMENDMENT_PATH = 'confirmcamendment';
export const CROSS_SELLING_PATH = 'crossselling';
export const SIGNATURE_STATUS_PATH = 'signature/status/:status';
export const SIGNATURE_STATUS_PATH_ENDORSEMENT =
  'signature/status/avenant/policyVersionStatus/:policyVersionStatus/policyStatus/:policyStatus';
export const ELECTRONIC_SIGNATURE_PATH = 'electronicsignature';
export const ELECTRONIC_SIGNATURE_PATH_AMENDMENT = 'electronicsignature-amendment';
export const PAYMENT_PATH = 'payment';
export const COLOC_PATH = 'coloc';
export const CANCELLATION_PATH = 'cancellation';
export const LESSOR_CERTIFICATE_PATH = 'lessorcertificate';
export const SERVICES_PATH = 'services';
export const CONFIRM_QUOTE_PATH = 'confirmquote';
export const SCHOOL_INSURANCE_PATH = 'schoolinsurance';
export const OFFER_CUSTOMIZARION_PATH = 'offercustomization';
export const RATE_PATH = 'rate';
export const INSURED_VALUE_PATH = 'insuredvalue';
export const PARTICULARITY_PATH = 'particularity';
export const START_CONTEXT_PATH = 'start/:context';
export const START_CONTEXT_PRODUCT_PATH = 'start/:context/:product';
export const NUMBER_PIECES_PATH = 'numberpieces';
export const LESSOR_PATH = 'lessor';
export const HOUSE_APARTMENT_PATH = 'houseapartment';
export const ROOMMATE_PATH = 'roommate';
export const START_PATH = 'start';
export const ROOMAREA_PATH = 'roomarea';
export const SUBSCRIBERHE_PATH = 'subscriber-student';
export const ADDRESS_PATH = 'address';
export const ETUDIANT_AGE_PATH = 'etudiant-age';
export const OWNER_TENANT_PATH = 'ownertenant';
export const PRIMARY_SECONDARY_PATH = 'primarysecondary';
export const PREFERENTIAL_RATE_PATH = 'preferentialrate';
export const PREVIOUS_CLAIM_PATH = 'previousclaim';
export const DEPENDENCY_PATH = 'dependency';
export const SUBSCRIBER_PATH = 'subscriber';
export const NOT_FOUND_PATH = '404';
export const ERROR_404_PATH = 'error404';
export const MAINTENANCE_PATH = 'maintenance';
export const ERROR_EMAIL_PATH = 'error-email';
